module.exports = __webpack_public_path__ + "img/Size=24, Style=solid.7196ed67.svg";